<template>
  <div class="py-6 px-8">
    <h-header title="Erro 404" />
    <div class="errorPage">
      <v-icon class="errorPage__icon" x-large>
        mdi-alert-circle-outline
      </v-icon>
      <h1 class="mb-8">{{ $t('pages.title.error404') }}</h1>
      <div class="text-right">
        <v-btn
          @click="() => $router.go(-1)"
          class="pl-10 pr-10"
          color="primary"
          type="submit"
          depressed
          large
          text
        >

          <h5 class="d-flex">
            <v-icon left>mdi-chevron-left</v-icon>
            {{ $t('auth.back') }}
          </h5>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error404',
}
</script>
